<script lang="ts">
    import type { OrganizationData } from "@anyways-open/identity-api-client";

    export let data: OrganizationData;

    let name = data.name;
    let description = data.description;
</script>

<div class="card-header">
    <h4 class="mb-0">Basic Information</h4>
</div>
<div class="card-body">
    <form>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="name">Name</label>
                    <input
                        class="form-control"
                        id="name"
                        type="text"
                        placeholder="Name"
                        value={name} />
                </div>
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label" for="description"
                        >Description</label>
                    <input
                        class="form-control"
                        id="description"
                        type="text"
                        placeholder="Description"
                        value={description} />
                </div>
            </div>
            <div class="col-12 col-md-auto">
                <button class="btn w-100 btn-primary" type="submit">
                    Save changes
                </button>
            </div>
        </div>
    </form>
</div>
